/**
 *
 * @param {(string|string[])} daysRaw
 * @param {(string|string[])} stagesRaw
 * @param {(string|string[])} tagsRaw
 * @param {string} searchText
 */

export default async function fetchData(daysRaw, stagesRaw, tagsRaw, searchTextRaw) {
  const homeUrl = window?.SiteGlobalVars?.homeUrl ? window?.SiteGlobalVars?.homeUrl : '';
  const url = homeUrl + '/wp-json/dt/v1/lectures';

  function returnArrayStringOrEmpty(parameterName, parameterValues) {
    if (!parameterValues) {
      return ''
    }

    if (Array.isArray(parameterValues)) {
      const arrayValues = parameterValues.map(((value) => (
        `${parameterName}[]=${value}`
      )))

      return arrayValues.join('&');
    }

    return `${parameterName}=${parameterValues}`
  }

  const days = returnArrayStringOrEmpty('days', daysRaw);
  const stages = returnArrayStringOrEmpty('stages', stagesRaw);
  const tags = returnArrayStringOrEmpty('tags', tagsRaw);
  const searchText = returnArrayStringOrEmpty('search', searchTextRaw);

  const response = await fetch(`${url}?${days}&${stages}&${tags}&${searchText}`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
    },
  })

  return response.json();
}
